<template>
  <div class="breadcrumb-container">
<!--    <div class="CaiDanBottom"></div>-->

<!--    <div class="banner-container">-->
<!--      src="@/assets/about/1111.jpg" class="image-about">-->
<!--    </div>-->

    <div class="research-content">
      <div class="tab-container" style="display: none;">
        <div class="tab-items">
          <div
              v-for="(tab, index) in tabs"
              :key="index"
              class="tab-item"
              :class="{ active: currentTab === index }"
              @click="switchTab(tab.path)"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="breadcrumb">
          <span class="breadcrumb-icon" ><img style="width: 2vw;bottom: 0;position: relative;top:0.2vw" src="@/assets/home/icon-home.png" alt="面包屑图标" /></span>
          <span>当前位置: </span>
          <span class="breadcrumb-link" @click="goToHome">首页</span>
          <span> > </span>
          <span class="breadcrumb-link" @click="goToAbout">关于海邻</span>
          <span> > </span>
          <span class="breadcrumb-link current">{{ currentTabName }}</span>
        </div>
      </div>

      <div class="research-containerA" :class="{ 'achievements-container': isAchievementsPage }">
        <transition name="fade" mode="out-in">
          <component :is="currentComponent"></component>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Caidan from "@/components/caidan.vue";
import About from "@/components/About/About.vue";
import History from "@/views/About/History.vue";
import Corporatehonors from "@/views/About/Corporatehonors.vue";
import Corporateculture from "@/views/About/Corporateculture.vue";

export default {
  name: "breadcrumb",
  components: {
    Caidan,
    About,
    History,
    Corporatehonors,
    Corporateculture,

  },
  data() {
    return {
      currentTab: 0,
      currentComponent: 'About',
      tabs: [
        { name: '企业简介', path: '/About' },
        { name: '发展历程', path: '/About/History' },
        { name: '企业荣誉', path: '/About/Corporatehonors' },
        { name: '企业文化', path: '/About/Corporateculture' },

      ]
    };
  },

  computed: {
    currentTabName() {
      return this.tabs[this.currentTab]?.name || '企业简介';
    },
    isAchievementsPage() {
      return this.$route.path.includes('/About/History');
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    goToAbout() {
      this.$router.push('/About').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    switchTab(path) {
      this.$router.push(path).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // 根据路由路径设置当前组件和标签
        if (to.path.includes('/About/History')) {
          this.currentComponent = 'History';
          this.currentTab = 1;
        } else if (to.path.includes('/About/Corporatehonors')) {
          this.currentComponent = 'Corporatehonors';
          this.currentTab = 2;
        } else if (to.path.includes('/About/Corporateculture')) {
          this.currentComponent = 'Corporateculture';
          this.currentTab = 3;
        } else {
          // 默认展示科研团队
          this.currentComponent = 'About';
          this.currentTab = 0;
        }

        // 更新页面标题
        document.title = this.tabs[this.currentTab]?.name || '关于海邻';
      }
    }
  },
  mounted() {
    document.title = this.currentTabName || '关于海邻';
  }
  //
  // methods: {
  //   navigateTo(path) {
  //     if (this.$route.path !== path) {
  //       this.$router.push(path).catch(err => {
  //         if (err.name !== 'NavigationDuplicated') throw err;
  //       });
  //     }
  //   },
  //   isTabActive(path) {
  //     return this.$route.path === path;
  //   },
  //   goToHome() {
  //     this.$router.push('/').catch(err => {
  //       if (err.name !== 'NavigationDuplicated') throw err;
  //     });
  //   },
  //   goToAbout() {
  //     this.$router.push('/About').catch(err => {
  //       if (err.name !== 'NavigationDuplicated') throw err;
  //     });
  //   },
  //   getCurrentTabName() {
  //     const currentTab = this.tabs.find(tab => tab.path === this.$route.path);
  //     return currentTab ? currentTab.name : '了解海邻';
  //   }
  // }
};
</script>
<style scoped>

.breadcrumb-container {
  width: 100%;
  /*min-height: 100vh;*/
  background-color: white;
  overflow-x: hidden; /* 隐藏水平滚动条 */
}

/* 隐藏 Webkit 浏览器的水平滚动条 */
.breadcrumb-container::-webkit-scrollbar:horizontal {
  display: none;
}

@media screen and (max-width: 768px) {
  .CaiDanBottom{
    height:100px;
    width: 100%;
  }
}
/* 针对 Firefox 的水平滚动条设置 */
.breadcrumb-container {
  scrollbar-width: none;
}

.banner-container {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
 /* margin-bottom: 50px;*/
  display: flex;
  justify-content: center;
  background-color: white;
}

.image-about {
  display: flex;
  position: relative;
  width: 100%;
  top: 0;
  height: auto;
}

.research-content {
  width: 100%;
  margin: 0 auto;
  padding: 0;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tab-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;

  background-color: #fff;
  position: relative;
  z-index: 10;
  margin-top: -85px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.tab-items {
  display: flex;
  flex: 1;
}

.tab-item {
  padding: 10px 15px;
  margin-right: 10px;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  white-space: nowrap;
  box-sizing: border-box;
  min-width: 84px;
  text-align: center;
  font-family: 'SourceHanSansCN', sans-serif;
  color: #4d4d4d;
}

.tab-item.active {
  color: #0099ff;
  font-weight: normal;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #0099ff;
}

.breadcrumb {
  color: #999;
  font-size: 14px;
  flex: 2;
  text-align: right;
  white-space: nowrap;
}

.breadcrumb-link {
  cursor: pointer;
}

.breadcrumb-link:hover {
  color: #666;
}

.breadcrumb-link.current {
  color: #0099ff;
  font-weight: 500;
}

.research-container {
  width: 100%;
  box-sizing: border-box;              /* 包含padding在宽度内 */

  /* 添加响应式断点 */
  @media (max-width: 1200px) {
    max-width: 100%; /* 大屏留白 */
  }
}

.research-section {
  margin-bottom: 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-title {
  padding: 15px 20px;
  color: white;
  font-size: 20px;
  margin: 0;
}

.section-content {
  padding: 20px;
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .research-container {
    width: 95%;
    padding: 0;
  }
  .tab-container {
    display: none;
  }
  .section-title {
    font-size: 18px;
    padding: 12px 15px;
  }

  .section-content {
    padding: 15px;
    font-size: 14px;
  }

  .tab-container {
    width: 95%;
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-start;
  }

  .breadcrumb {
    margin-top: 10px;
    text-align: left;
    width: 100%;
  }

  .tab-items {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 5px;
  }
}

@media screen and (max-width: 480px) {
  .tab-item {
    font-size: 14px;
    padding: 8px 10px;
    min-width: 70px;
  }

  .section-title {
    font-size: 16px;
    padding: 10px 15px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.achievements-container {

}
</style>
<!--<style scoped>-->
<!--.breadcrumb-container {-->
<!--  width: 100%;-->
<!--  margin: 0 auto;-->
<!--  padding: 0;-->
<!--  position: relative;-->
<!--  z-index: 2;-->
<!--  font-family: 'SourceHanSansCN', sans-serif;-->
<!--}-->

<!--.tab-container {-->
<!--  display: flex;-->
<!--  justify-content: space-between;-->
<!--  align-items: center;-->
<!--  border-bottom: 1px solid #e5e5e5;-->
<!--  padding: 15px 20px;-->
<!--  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);-->
<!--  background-color: #fff;-->
<!--  position: relative;-->
<!--  z-index: 10;-->
<!--  margin-top: -95px;-->
<!--  width: 90%;-->
<!--  max-width: 1400px;-->
<!--  margin-left: auto;-->
<!--  margin-right: auto;-->
<!--}-->

<!--.tab-items {-->
<!--  display: flex;-->
<!--  flex: 1;-->
<!--}-->

<!--.tab-item {-->
<!--  padding: 10px 15px;-->
<!--  margin-right: 10px;-->
<!--  cursor: pointer;-->
<!--  position: relative;-->
<!--  font-size: 16px;-->
<!--  white-space: nowrap;-->
<!--  box-sizing: border-box;-->
<!--  min-width: 84px;-->
<!--  text-align: center;-->
<!--  color: #4d4d4d;-->
<!--}-->

<!--.tab-item.active {-->
<!--  color: #0099ff;-->
<!--  font-weight: normal;-->
<!--}-->

<!--.tab-item.active::after {-->
<!--  content: '';-->
<!--  position: absolute;-->
<!--  bottom: -10px;-->
<!--  left: 0;-->
<!--  width: 100%;-->
<!--  height: 3px;-->
<!--  background-color: #0099ff;-->
<!--}-->

<!--.breadcrumb {-->
<!--  color: #999;-->
<!--  font-size: 14px;-->
<!--  flex: 2;-->
<!--  text-align: right;-->
<!--  white-space: nowrap;-->
<!--}-->

<!--.breadcrumb-link {-->
<!--  cursor: pointer;-->
<!--}-->

<!--.breadcrumb-link:hover {-->
<!--  color: #4d4d4d;-->
<!--}-->

<!--.breadcrumb-link.current {-->
<!--  color: #0099ff;-->
<!--  /*font-weight: 500;*/-->
<!--}-->

<!--@media screen and (max-width: 768px) {-->
<!--  .tab-container {-->
<!--    width: 95%;-->
<!--    padding: 10px 15px;-->
<!--    flex-direction: column;-->
<!--    align-items: flex-start;-->
<!--  }-->
<!--  .tab-container {-->
<!--    display: none;-->
<!--  }-->
<!--  .breadcrumb {-->
<!--    margin-top: 10px;-->
<!--    text-align: left;-->
<!--    width: 100%;-->
<!--  }-->

<!--  .tab-items {-->
<!--    width: 100%;-->
<!--    overflow-x: auto;-->
<!--    padding-bottom: 5px;-->
<!--  }-->
<!--}-->
<!--</style>-->
